import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModuleUsageDashboardResponse, ModuleUsageDashboardResponseView } from "services";

interface State {
    isFetching: boolean;
    fetchError: boolean;
    fetchSuccess: boolean;
    errorMessage: string;
    data: ModuleUsageDashboardResponse | null;
}

interface RequestError {
    errorMessage: string;
}

const initialState: State = {
    isFetching: false,
    fetchError: false,
    fetchSuccess: false,
    errorMessage: "",
    data: null,
};

const moduleUsageDataSlice = createSlice({
    name: "ModuleUsageData",
    initialState: initialState,
    reducers: {
        getModuleUsageDataRequest: state => {
            state.isFetching = true;
        },
        getModuleUsageDataSuccess: (
            state,
            action: PayloadAction<ModuleUsageDashboardResponseView>
        ) => {
            state.isFetching = false;
            state.fetchSuccess = true;
            state.data = action.payload.data;
        },
        getModuleUsageDataError: (state, action: PayloadAction<RequestError>) => {
            state.isFetching = false;
            state.fetchError = true;
            state.errorMessage = action.payload.errorMessage;
        },
    },
});

const { actions } = moduleUsageDataSlice;

export const { getModuleUsageDataRequest, getModuleUsageDataSuccess, getModuleUsageDataError } =
    actions;

export const moduleUsageDataReducer = moduleUsageDataSlice.reducer;
